import { createRouter, createWebHistory } from 'vue-router';

import { useRouterStore } from '@apps/main/new-desktop/core/stores';
import {
  TripPlannerPage,
  mapFullPathToTripPlannerPage,
} from '@apps/main/new-desktop/core/models/navigation';

import { TripPlannerRoute } from './tripPlannerRoute';

const router = createRouter({
  history: createWebHistory(),
  routes: [TripPlannerRoute.config],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }

    const isSameParent = to.matched[1]?.name === from.matched[1]?.name;

    return isSameParent ? false : { top: 0 };
  },
});

router.beforeEach((to, from) => {
  const routerStore = useRouterStore();
  routerStore.previousTripPlannerPage = mapFullPathToTripPlannerPage(
    from.fullPath
  );

  // NOTE: This part redirects
  // * form: /travel/plan?pax=rpp
  // * to:   /travel/plan/overview?pax=rpp
  // which is required for meta redirection
  if (to.name === TripPlannerPage.BaseURL) {
    return {
      name: TripPlannerPage.TripOverview,
      query: to.query,
    };
  }
});

export default router;
